// import { Api } from '../api';
import { Api } from '../api';
import { payments } from '../endpoints';
import type {
  CheckLimitRequest,
  CheckLimitResponse,
  ExternalRequest,
  GetRequisitesResponse,
  PostRequisitesRequest,
  PostRequisitesResponse,
} from './models';

export class PaymentsApi extends Api {
  static getRequisites = (signal?: AbortSignal) => this.get<GetRequisitesResponse[]>(payments.requisites(), { signal });

  static checkLimit = (request: CheckLimitRequest, signal?: AbortSignal) => this.post<CheckLimitResponse>(payments.checkLimit(), request, { signal });

  static postRequisites = (request: PostRequisitesRequest, signal?: AbortSignal) =>
    this.post<PostRequisitesResponse>(payments.requisites(), request, { signal });

  static deleteRequisites = (id: string, signal?: AbortSignal) => this.delete<null>(payments.deleteRequisites(id), { responseType: 'none', signal });

  static external = (request: ExternalRequest, signal?: AbortSignal) => this.post<PostRequisitesResponse>(payments.external(), request, { signal });

  static internal = (request: ExternalRequest, signal?: AbortSignal) => this.post<PostRequisitesResponse>(payments.internal(), request, { signal });
}
